import { initialState } from "../money.slice";

const resetMoneyCategories = () => {
    return initialState;
}

export default resetMoneyCategories;